type Tuple = readonly [key: string|number, value: any]

export function findFromTuple<T extends Tuple[]>(key: T[number][0], values: Readonly<T>) {
  const result = values.find(v => v[0] === key)
  return result as T[number]
}
